import {useCallback, useEffect, useState} from 'react';

const KEYCODES = {
    TAB: 9,
    ENTER: 13,
    ESCAPE: 27,
    UP: 38,
    DOWN: 40
};

function DropdownFocus(open:boolean, node:any, size:number, setOpen:Function) {
    const [currentFocus, setCurrentFocus] = useState(0);
    const handleKeyDown = useCallback(
        (e: any) => {
            if (open && e.keyCode === KEYCODES.DOWN) {
                e.preventDefault();
                setCurrentFocus(currentFocus === size ? 0 : currentFocus + 1);
            } else if (e.keyCode === KEYCODES.UP) {
                e.preventDefault();
                setCurrentFocus(currentFocus === 0 ? size - 1 : currentFocus - 1);
            } else if (open && e.keyCode === KEYCODES.TAB) {
                e.preventDefault();
                setCurrentFocus(currentFocus === size ? 0 : currentFocus + 1);
            } else if (e.keyCode === KEYCODES.ESCAPE) {
                e.preventDefault();
                setOpen(false);
            }
        },
        [open, size, currentFocus, setCurrentFocus, setOpen]
    );

    useEffect(() => {
        const ref = node.current;
        if (ref) {
            ref.addEventListener('keydown', handleKeyDown, false);
            return () => {
                ref.removeEventListener('keydown', handleKeyDown, false);
            };
        }

    }, [node, handleKeyDown]);


    return [currentFocus, setCurrentFocus];
}

export default DropdownFocus;
